var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function CopyIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 9V3.9985C9 3.44705 9.44851 3 10.0025 3H19.9975C20.5512 3 21 3.44851 21 4.00247V13.9975C21 14.5512 20.5546 15 20.0041 15H15V19.9975C15 20.5512 14.5515 21 13.9975 21H4.00247C3.44882 21 3 20.5515 3 19.9975V10.0025C3 9.44882 3.44851 9 4.00247 9H9ZM11.0052 9H13.9975C14.5512 9 15 9.44851 15 10.0025V13H19.0035L19 5H11.0267L11.0052 9ZM4.99347 19.0009L13.0006 19.0084L13.0057 11H5.01251L4.99347 19.0009Z", fill: "" })));
}
export var CopyIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: CopyIconInner }, props))); };
//# sourceMappingURL=CopyIcon.js.map